import logoSymbol from '../../../logo/logo-2026-divitta-simbolo-fundotransparente.png';

const LogoIcon = () => <img src={logoSymbol} alt="DiVitta" style={{ width: 35, height: 35, display: 'block' }} />;

export default LogoIcon;
